import React from 'react';
import { motion } from 'framer-motion';
import { Scale, Shield, AlertCircle, Mail } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      
      <main className="pt-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center space-x-3 mb-8">
              <Scale className="w-8 h-8 text-blue-400" />
              <h1 className="text-4xl font-bold">Terms of Service</h1>
            </div>

            <div className="prose prose-invert max-w-none">
              <p className="text-lg text-gray-400 mb-8">
                Last updated: March 20, 2024
              </p>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <Shield className="w-6 h-6 mr-2 text-blue-400" />
                  Membership Terms
                </h2>
                <div className="space-y-4">
                  <p>
                    By accessing and using our facilities, you agree to be bound by these terms and conditions. Please read them carefully.
                  </p>
                  <h3 className="text-xl font-bold">1. Membership Agreement</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Membership is subject to our rules and regulations</li>
                    <li>Members must be at least 16 years of age</li>
                    <li>Membership is non-transferable</li>
                    <li>Membership fees are subject to change with notice</li>
                  </ul>
                  <h3 className="text-xl font-bold">2. Payment Terms</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Membership fees are paid in advance</li>
                    <li>Direct debit payments are processed weekly</li>
                    <li>Failed payments may result in suspension of membership</li>
                    <li>Cancellation requires 30 days written notice</li>
                  </ul>
                </div>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4">Facility Rules</h2>
                <div className="space-y-4">
                  <h3 className="text-xl font-bold">1. General Conduct</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Respect all members and staff</li>
                    <li>Follow proper gym etiquette</li>
                    <li>Clean equipment after use</li>
                    <li>Wear appropriate athletic attire</li>
                  </ul>
                  <h3 className="text-xl font-bold">2. Safety</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Follow all posted safety guidelines</li>
                    <li>Report any equipment issues to staff</li>
                    <li>Use equipment as intended</li>
                    <li>Do not train while under the influence</li>
                  </ul>
                </div>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <AlertCircle className="w-6 h-6 mr-2 text-blue-400" />
                  Liability and Risk
                </h2>
                <div className="space-y-4">
                  <p>
                    While we maintain high safety standards, members acknowledge that exercise carries inherent risks. By using our facilities, you:
                  </p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Accept responsibility for your own safety</li>
                    <li>Agree to follow staff instructions</li>
                    <li>Understand the risks of physical activity</li>
                    <li>Release us from liability for ordinary negligence</li>
                  </ul>
                </div>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4">Termination</h2>
                <p className="mb-4">
                  We reserve the right to terminate memberships for:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Violation of these terms</li>
                  <li>Inappropriate behavior</li>
                  <li>Non-payment of fees</li>
                  <li>False information provision</li>
                </ul>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4">Privacy</h2>
                <p>
                  Your privacy is important to us. We collect and use personal information in accordance with our Privacy Policy, which is incorporated into these terms by reference.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-bold mb-4">Changes to Terms</h2>
                <p>
                  We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to our website. Continued use of our facilities constitutes acceptance of modified terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 flex items-center">
                  <Mail className="w-6 h-6 mr-2 text-blue-400" />
                  Contact
                </h2>
                <p>
                  For questions about these terms, please contact us at:{' '}
                  <a href="mailto:info@thefitnessportal.co.nz" className="text-blue-400 hover:text-blue-300">
                    info@thefitnessportal.co.nz
                  </a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
}